// Recovered compiled webpack factory 10531. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      RedirectBoundary: function () {
        return f;
      },
      RedirectErrorBoundary: function () {
        return c;
      },
    }));
  let n = r(49417),
    a = r(95155),
    o = n._(r(12115)),
    i = r(47260),
    s = r(86542),
    l = r(86437);
  function u(e) {
    let { redirect: t, reset: r, redirectType: n } = e,
      a = (0, i.useRouter)();
    return (
      (0, o.useEffect)(() => {
        o.default.startTransition(() => {
          (n === l.RedirectType.push ? a.push(t, {}) : a.replace(t, {}), r());
        });
      }, [t, n, r, a]),
      null
    );
  }
  class c extends o.default.Component {
    static getDerivedStateFromError(e) {
      if ((0, l.isRedirectError)(e))
        return {
          redirect: (0, s.getURLFromRedirectError)(e),
          redirectType: (0, s.getRedirectTypeFromError)(e),
        };
      throw e;
    }
    render() {
      let { redirect: e, redirectType: t } = this.state;
      return null !== e && null !== t
        ? (0, a.jsx)(u, {
            redirect: e,
            redirectType: t,
            reset: () => this.setState({ redirect: null }),
          })
        : this.props.children;
    }
    constructor(e) {
      (super(e), (this.state = { redirect: null, redirectType: null }));
    }
  }
  function f(e) {
    let { children: t } = e,
      r = (0, i.useRouter)();
    return (0, a.jsx)(c, { router: r, children: t });
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
